import React from 'react';
import { Helmet } from 'react-helmet-async';
import '../news.css';
import Content from './955c81631539.jpg';
import { newsData } from '../newsData';
import NavigationButtons from '../navigationButtons';

const Nachisleniya = () => {
    const pathname = window.location.pathname;
    const currentNewsIndex = newsData.findIndex(item => pathname.includes(item.url));
  
    const prevNewsIndex = currentNewsIndex > 0 ? currentNewsIndex - 1 : null;
    const nextNewsIndex = currentNewsIndex < newsData.length - 1 ? currentNewsIndex + 1 : null;
  
    const currentNews = newsData[currentNewsIndex];

  return (
    <article>
      <Helmet defer={false}>
        <title>Вопросы о начислениях за ЖКУ | ООО УК «ВЕХА»</title>
        <meta name="description" content="Ответы на часто задаваемые вопросы о начислениях за жилищно-коммунальные услуги." />
      </Helmet>
    <div>
     <h2 className='news_header'>ВОПРОСЫ О НАЧИЛЕНИЯХ ЗА ЖКУ?</h2>
    <div className='news_content'>
    <NavigationButtons prevNewsIndex={prevNewsIndex} nextNewsIndex={nextNewsIndex} />
    <p>Опубликовано {currentNews.date}</p>
    <img src={Content} />
    </div>
</div>
</article>
  );
};

export default Nachisleniya;